<template>
  <div v-show="route.name === 'personal' || route.name === 'appliancepersonal'">
    <header-menu />
    <div class="header">
      <div class="active">
        <img :src="store.userInfo.avatar" alt="" />
      </div>
      <div class="userInfo" @click="data.goUserInfoLink">
        <div>
          <div class="userName">
            {{ store.userInfo ? store.userInfo.nickname : "我是名字七个字" }}
          </div>
          <div class="userIphone">
            {{ store.userInfo ? store.userInfo.phone : "188888888888" }}
            <img
              v-if="store.userInfo && store.userInfo.member_level === 2"
              src="@/assets/vip.png"
              alt=""
            />
            <img v-else src="@/assets/member.png" alt="" />
          </div>
        </div>
        <img class="right" src="@/assets/invite_right.png" alt="" />
      </div>
    </div>
    <div class="vipCard">
      <div class="vipHeader">
        <img
          v-if="store.userInfo && store.userInfo.member_level === 2"
          src="@/assets/vip.png"
          alt=""
        />
        <img v-else src="@/assets/member.png" alt="" />
        <van-swipe
          class="Vipswipe"
          :autoplay="3000"
          vertical
          :show-indicators="false"
        >
          <van-swipe-item>
            <span class="text">专享VIP特权，同时每月送1000花瓣</span>
          </van-swipe-item>
          <van-swipe-item v-if="store.userInfo.member_level === 2">
            <span class="text" style="color: #8368fc"
              >有效期至{{ store.userInfo.member_expire_time }}</span
            >
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="vipName">
        花瓣
        <van-popover v-model:show="showPopover" placement="bottom-start">
          <template #reference>
            <img src="@/assets/question.png" alt="" />
          </template>
          <div class="tip">
            <div class="title">花瓣用途</div>
            <div class="text">用于AI文案写作、AI创意绘画、各种行业AI应用</div>
            <div class="text">获得途径：开通会员赠送、直接充值、点赞分享等</div>
          </div>
        </van-popover>
      </div>
      <div class="vipBottom">
        <div class="vipWallet">
          <div class="vipMoney">
            {{
              store.userInfo.petal_balance ? store.userInfo.petal_balance : 0
            }}
          </div>
          <div
            class="vipRecharge"
            :style="
              store.userInfo.member_level === 2
                ? 'background:#ffffff;color:#8368FC'
                : ''
            "
            @click="data.goTemplate('recharge')"
          >
            充值
          </div>
        </div>
        <div class="vipOpen" @click="data.goTemplate('recharge')">
          {{ store.userInfo.member_level === 2 ? "续费会员" : "开通会员"
          }}<img src="@/assets/colorRight.png" alt="" />
        </div>
      </div>
    </div>
    <div class="call">
      <div
        class="item"
        v-for="(item, index) in data.callList"
        @click="data.goTemplate(item.title)"
        :key="index"
      >
        <div class="left">
          {{ item.title }}
          <div
            :class="store.userInfo.member_level === 2 ? 'vipIcon' : 'noVip'"
            v-if="item.title === '私人画夹'"
          >
            VIP
          </div>
        </div>
        <div class="right">{{ item.tip }} <van-icon name="arrow" /></div>
      </div>
    </div>
    <div class="record">
      <div>Copyright © 2023 浙江花集网科技股份有限公司</div>
      <div>
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >浙ICP备11057651号-8</a
        >
      </div>
    </div>
  </div>
  <router-view />
  <div class="m-share" id="share"></div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  onUnmounted,
} from "vue";
import { useCounterStore } from "@/store";
import { useInviteStore } from "@/store/invite";
import { useRoute, useRouter } from "vue-router";
import headerMenu from "@/components/headerMenu.vue";
import { userInfo } from "@/api/login";
import { getToken } from "@/ulits/auth";
import share from "m-share";

/**
 * 仓库
 */
const store = useCounterStore();
const inviteStore = useInviteStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
data.userInfo = localStorage.getItem("userInfo");
if (getToken() && data.userInfo) {
  userInfo({ user_id: JSON.parse(data.userInfo).id }).then((user) => {
    if (user.code === 200) {
      store.setUserInfo(user.data);
      localStorage.setItem("userInfo", JSON.stringify(user.data));
    }
  });
}

data.shareWx = () => {
  share.to("wx");
  if (/android/i.test(navigator.userAgent)) {
    wx.onMenuShareAppMessage({
      title: "花集AI精灵",
      desc: "智慧伴你 随心所欲",
      link: "https://www.aibene.cn",
      imgUrl:
        "https://aibene-resource.huaji.com/png/20231010/202310101603452738.png",
    });
  }
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    wx.updateAppMessageShareData({
      title: "花集AI精灵",
      desc: "智慧伴你 随心所欲",
      link: "https://www.aibene.cn",
      imgUrl:
        "https://aibene-resource.huaji.com/png/20231010/202310101603452738.png",
    });
  }
};

data.callList = [
  {
    title: "账单明细",
    tip: "花瓣消费明细",
  },
  {
    title: "私人画夹",
    tip: "非VIP用户仅保留7天内作品",
  },
  {
    title: "使用教程",
    tip: "更多福利/技巧/资源/教程",
  },
  {
    title: "加入官方微信交流群",
    tip: "加群送100花瓣",
  },
  {
    title: "邀请好友",
    tip: "成为精灵团长 与好友一起做副业变现",
  },
  {
    title: "联系客服",
    tip: "",
  },
  {
    title: "关于我们",
    tip: "",
  },
];

const showPopover = ref(false);

data.goTemplate = (e) => {
  switch (e) {
    case "账单明细":
      router.push({
        name: "bill",
      });
      break;
    case "私人画夹":
      router.push({
        name: "paintings",
      });
      break;
    case "recharge":
      router.push({
        name: "recharge",
      });
      break;
    case "使用教程":
      window.open(
        "https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf"
      );
      break;
    case "加入官方微信交流群":
      window.open(
        "https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf#PWtfdCqnIozYJcxhYt8cVeMQn8g"
      );
      break;
    case "联系客服":
      window.open(
        "https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf#XxxOddEUEoKaALxivq0cc9qmn6v"
      );
      break;
    case "关于我们":
      window.open(
        "https://huajiwang.feishu.cn/wiki/BGN5wBnW9ibJ7GkiF6JctJQDnAf"
      );
      break;
    case "邀请好友":
      // data.shareWx()
      router.push({
        name: "invite",
      });
      break;
  }
};

data.goUserInfoLink = () => {
  router.push({
    name:'userInfo'
  })
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});

watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.header {
  height: calc(214 / 1624 * 100vh);
  display: flex;
  align-items: center;
  padding: 0 48px;
  .active {
    img {
      width: 118px;
      height: 118px;
      border-radius: 118px;
      background: #2d2e47;
    }

    margin-right: 12px;
    border-radius: 118px;
  }
  .userInfo {
    color: #ffffffff;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .right {
      width: 44px;
      height: 44px;
    }
    .userName {
      font-size: 34px;
    }
    .userIphone {
      font-size: 28px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      img {
        margin-left: 8px;
        width: 106px;
        height: 40px;
      }
    }
  }
}
.Vipswipe {
  height: 40px;
}
.vipCard {
  background: url("~@/assets/flower.png") no-repeat;
  background-size: 176px;
  background-position: right top;
  background-color: #ded7fdff;
  border-radius: 48px;
  padding: 32px;
  margin: 0 24px;
  .vipHeader {
    display: flex;
    align-items: center;
    img {
      margin-right: 8px;
      width: 106px;
      height: 40px;
    }
    .text {
      font-size: 28px;
      border-left: 1px solid #666666ff;
      color: #666666ff;
      padding-left: 10px;
    }
  }
  .vipName {
    margin-top: 26px;
    color: #666666ff;
    font-size: 32px;
    display: flex;
    align-items: center;
    img {
      margin-left: 8px;
      width: 28px;
      height: 28px;
    }
  }
  .vipBottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .vipWallet {
      display: flex;
      align-items: center;
      margin-top: 3px;
    }
    .vipMoney {
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #8368fc;
      font-size: 60px;
      margin-right: 24px;
    }
    .vipRecharge {
      width: 128px;
      height: 60px;
      background: #8368fc;
      border-radius: 30px;
      font-size: 30px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 60px;
    }
    .vipOpen {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #8368fc;
      img {
        width: 44px;
        height: 44px;
      }
    }
  }
}
.call {
  margin-top: 32px;
  height: calc(100vh - 670px);
  overflow: hidden;
  overflow-y: auto;
  .item {
    display: flex;
    justify-content: space-between;
    font-size: 30px;
    padding: 28px 48px;
    .left {
      color: #ffffffff;
      display: flex;
      align-items: center;
      .vipIcon {
        margin-left: 8px;
        width: 88px;
        height: 36px;
        line-height: 36px;
        background: linear-gradient(119deg, #fddb9e 0%, #e3b15b 100%);
        border-radius: 8px;
        font-weight: bold;
        color: #291d0f;
        font-size: 30px;
        text-align: center;
        font-family: DINAlternate-Bold, DINAlternate;
      }
      .noVip {
        margin-left: 8px;
        width: 88px;
        height: 36px;
        line-height: 36px;
        background: linear-gradient(119deg, #cccccc 0%, #999999 100%);
        border-radius: 8px;
        font-weight: bold;
        color: #ffffff;
        font-size: 30px;
        text-align: center;
        font-family: DINAlternate-Bold, DINAlternate;
      }
    }
    .right {
      display: flex;
      align-items: center;
      color: #f7f5ff80;
    }
  }
}
.record {
  position: fixed;
  bottom: 0;
  width: 100vw;
  text-align: center;
  padding-bottom: 30px;
  font-size: 24px;
  color: #f7f5ff60;
  a {
    color: #f7f5ff60;
  }
}
.tip {
  background: #ffffff;
  padding: 20px;
  .title {
    font-size: 28px;
  }
  .text {
    font-size: 24px;
  }
}
</style>
<style>
:root {
  --van-padding-md: 20px !important;
  --van-popover-light-background: #ffffff !important;
}
</style>
